module.exports = __webpack_public_path__ + "img/white-logo-en-express.a8f0ae8.webp";